import { Container } from '@mui/material';
import React from 'react';
import FrogGif from '../../Attachments/2c80d2ced9451189047bc6f0c8a54852.gif'

const Blogs = () => {
    return (
        <Container>
            <h1>Blogs Coming soon</h1>
            <img style={{ width: '100%' }} src={FrogGif} alt="" />
        </Container>
    );
};

export default Blogs;